import type { ToolUIPart } from '@modernloop/ai-elements';
import { AGENT_CHAT_ITEM, AGENT_TOOL_STATUS, type AgentChatItem } from './chatItems';

const toolStateByStatus = {
  [AGENT_TOOL_STATUS.RUNNING]: 'input-available',
  [AGENT_TOOL_STATUS.SUCCEEDED]: 'output-available',
  [AGENT_TOOL_STATUS.FAILED]: 'output-error',
} as const satisfies Record<(typeof AGENT_TOOL_STATUS)[keyof typeof AGENT_TOOL_STATUS], ToolUIPart['state']>;

/** Maps the typed agent transcript protocol onto the minimal AI Elements view vocabulary. */
export const toElementTool = (
  item: Pick<Extract<AgentChatItem, { type: typeof AGENT_CHAT_ITEM.TOOL_ACTIVITY }>, 'toolName' | 'status'>
): Pick<ToolUIPart, 'type' | 'state'> => ({
  type: `tool-${item.toolName}`,
  state: toolStateByStatus[item.status],
});
